import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../components/ui'
import './NotFound.css'

function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Страница не найдена</h2>
        <p>Запрашиваемая страница не существует или была перемещена.</p>
        <Button type="button" variant="primary" onClick={() => navigate('/')}>
          Вернуться на главную
        </Button>
      </div>
    </div>
  )
}

export default NotFound

